var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScheduleHighlight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(825.146 -478.535)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 2.974,
    transform: "translate(-820.754 478.535)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 2.974,
    transform: "translate(-812.551 478.535)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.746,
    height: 1.2,
    transform: "translate(-818.985 479.422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-810.631,479.28v1.2h2.287v1.461h-15.6v-1.461h2.455v-1.2h-3.653v17.107h18V479.28Zm2.287,15.907h-15.6V483.136h15.6Z",
    transform: "translate(0 0.147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-817.1,489.931l-2.454,1.909.918-3.055-2.495-1.853,3.055-.037.915-3.055.977,3.035,3.053-.036-2.453,1.909.977,3.035Z",
    transform: "translate(0.985 1.195)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScheduleHighlight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/schedule-highlight.a04abfbf36c66c8e296fcf192d67cf2e.svg";